import React from 'react';
import "./index.scss";

const ReceiveCoupon: React.FC = () =>  {
  return(
    <div className='page'>
      <div>
        <img src={require("@/images/empty_coupon.png")} alt="失败" />
      </div>
      <div className='text'>领取失败</div>
    </div>
  )
};

export default ReceiveCoupon;